export const toObjectAsync = async (source, selector) => {
    const map = {};
    for (const value of source) {
        map[await selector(value)] = value;
    }
    return map;
};
